"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_STATUSES = exports.buildTimeoutReasonSchema = exports.BuildTimeoutReason = exports.buildStatusSchema = exports.BuildStatus = void 0;
exports.isBuildStatus = isBuildStatus;
exports.isActiveProcessingStatus = isActiveProcessingStatus;
exports.isFinalBuildStatus = isFinalBuildStatus;
exports.isBomReadyOrLaterStatus = isBomReadyOrLaterStatus;
const z = require("zod");
var BuildStatus;
(function (BuildStatus) {
    BuildStatus["Pending"] = "pending";
    BuildStatus["Validating"] = "validating";
    BuildStatus["Processing"] = "processing";
    BuildStatus["BomAwaitingReview"] = "bom_awaiting_review";
    BuildStatus["ProcessingBom"] = "processing_bom";
    BuildStatus["ReadyToAnalyze"] = "ready_to_analyze";
    BuildStatus["ProcessingDesign"] = "processing_design";
    BuildStatus["AnalysisComplete"] = "analysis_complete";
    BuildStatus["Complete"] = "complete";
    BuildStatus["Error"] = "error";
    BuildStatus["Abandoned"] = "abandoned";
    BuildStatus["TimedOut"] = "timed_out";
    BuildStatus["CreditRequired"] = "credit_required";
    BuildStatus["Unknown"] = "unknown";
})(BuildStatus || (exports.BuildStatus = BuildStatus = {}));
exports.buildStatusSchema = z.nativeEnum(BuildStatus);
var BuildTimeoutReason;
(function (BuildTimeoutReason) {
    BuildTimeoutReason["ParseWait"] = "parse_wait";
    BuildTimeoutReason["NetlistWait"] = "netlist_wait";
})(BuildTimeoutReason || (exports.BuildTimeoutReason = BuildTimeoutReason = {}));
exports.buildTimeoutReasonSchema = z.nativeEnum(BuildTimeoutReason);
function isBuildStatus(value) {
    return Object.values(BuildStatus).includes(value);
}
exports.BUILD_STATUSES = Object.values(BuildStatus);
function isActiveProcessingStatus(status) {
    switch (status) {
        case BuildStatus.Pending:
        case BuildStatus.Validating:
        case BuildStatus.Processing:
        case BuildStatus.ProcessingBom:
        case BuildStatus.ProcessingDesign:
            return true;
    }
    return false;
}
function isFinalBuildStatus(status) {
    switch (status) {
        case BuildStatus.Complete:
        case BuildStatus.Error:
        case BuildStatus.Abandoned:
        case BuildStatus.TimedOut:
        case BuildStatus.CreditRequired:
            return true;
    }
    return false;
}
function isBomReadyOrLaterStatus(status) {
    switch (status) {
        case BuildStatus.BomAwaitingReview:
        case BuildStatus.ProcessingBom:
        case BuildStatus.ReadyToAnalyze:
        case BuildStatus.ProcessingDesign:
        case BuildStatus.AnalysisComplete:
        case BuildStatus.Complete:
            return true;
    }
    return false;
}
//# sourceMappingURL=build-status.js.map